'use client';
import { useRef, type PropsWithChildren } from 'react';
import { Provider } from 'react-redux';
import { makeStore, type AppStore } from '@witmetrics/data-store';

export default function ReduxProvider({ children }: PropsWithChildren) {
  const storeRef = useRef<AppStore | undefined>(undefined);
  if (!storeRef.current) storeRef.current = makeStore();
  return <Provider store={storeRef.current}>{children}</Provider>;
}
